import { render } from "./InquiryDetail.vue?vue&type=template&id=5d9bd045&scoped=true"
import script from "./InquiryDetail.vue?vue&type=script&lang=js"
export * from "./InquiryDetail.vue?vue&type=script&lang=js"

import "./InquiryDetail.vue?vue&type=style&index=0&id=5d9bd045&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9bd045"]])

export default __exports__